<div class="verify-email-container">
  <div class="verify-email-wrapper">
    <!-- Left Section -->
    <div class="verify-email-left">
      <div class="auth-overlay"></div>
      <div class="auth-image"></div>
      <img src="assets/layout/images/branding/kairos-wordmark.svg" alt="Logo" class="logo-sidebar">
    </div>

    <!-- Right Section -->
    <div class="verify-email-right">
      <div class="form-content-wrapper">
        <!-- Logo (only visible on mobile) -->
        <img src="assets/layout/images/branding/kairos-wordmark.svg" alt="Logo" class="logo-mobile">

        <!-- Pending State -->
        @if (status === 'pending') {
          <div class="status-container pending">
            <div class="status-icon">
              <lucide-icon name="Mail" [size]="64"></lucide-icon>
            </div>
            <h1 class="status-title">{{ 'auth.verifyEmail.pending.title' | transloco }}</h1>
            <p class="status-message">{{ 'auth.verifyEmail.pending.message' | transloco }}</p>
            @if (email) {
              <p class="email-sent-to">{{ email }}</p>
            }

            <div class="actions">
              @if (email) {
                <app-button
                  [label]="resendDisabled
                    ? ('auth.verifyEmail.resendIn' | transloco: { seconds: resendCountdown })
                    : ('auth.verifyEmail.resend' | transloco)"
                  (onClick)="resendEmail()"
                  [disabled]="resendDisabled"
                  variant="secondary"
                  class="action-button"
                ></app-button>
              }
              <app-button
                [label]="'auth.verifyEmail.backToLogin' | transloco"
                (onClick)="navigateToLogin()"
                variant="link"
                class="back-link"
              ></app-button>
            </div>
          </div>
        }

        <!-- Verifying State -->
        @if (status === 'verifying') {
          <div class="status-container verifying">
            <div class="status-icon spinner">
              <lucide-icon name="Loader2" [size]="64"></lucide-icon>
            </div>
            <h1 class="status-title">{{ 'auth.verifyEmail.verifying.title' | transloco }}</h1>
            <p class="status-message">{{ 'auth.verifyEmail.verifying.message' | transloco }}</p>
          </div>
        }

        <!-- Success State -->
        @if (status === 'success') {
          <div class="status-container success">
            <div class="status-icon success-icon">
              <lucide-icon name="CircleCheck" [size]="64"></lucide-icon>
            </div>
            <h1 class="status-title">{{ 'auth.verifyEmail.success.title' | transloco }}</h1>
            <p class="status-message">{{ 'auth.verifyEmail.success.message' | transloco }}</p>

            <div class="actions">
              <app-button
                [label]="'auth.verifyEmail.success.button' | transloco"
                (onClick)="navigateToLogin()"
                class="action-button"
              ></app-button>
            </div>
          </div>
        }

        <!-- Error State -->
        @if (status === 'error') {
          <div class="status-container error">
            <div class="status-icon error-icon">
              <lucide-icon name="CircleX" [size]="64"></lucide-icon>
            </div>
            <h1 class="status-title">{{ 'auth.verifyEmail.error.title' | transloco }}</h1>
            <p class="status-message">{{ errorMessage || ('auth.verifyEmail.error.message' | transloco) }}</p>

            <div class="actions">
              @if (email) {
                <app-button
                  [label]="resendDisabled
                    ? ('auth.verifyEmail.resendIn' | transloco: { seconds: resendCountdown })
                    : ('auth.verifyEmail.resend' | transloco)"
                  (onClick)="resendEmail()"
                  [disabled]="resendDisabled"
                  variant="secondary"
                  class="action-button"
                ></app-button>
              }
              <app-button
                [label]="'auth.verifyEmail.backToLogin' | transloco"
                (onClick)="navigateToLogin()"
                variant="link"
                class="back-link"
              ></app-button>
            </div>
          </div>
        }
      </div>
    </div>
  </div>
</div>
